import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


export default function TiktokIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g>
        <path
          d="M12.944,1.611v14.167   c0,1.565-1.269,2.833-2.833,2.833h0c-1.565,0-2.833-1.269-2.833-2.833v0c0-1.565,1.269-2.833,2.833-2.833h0V9.167h0   c-3.651,0-6.611,2.96-6.611,6.611v0c0,3.651,2.96,6.611,6.611,6.611h0c3.651,0,6.611-2.96,6.611-6.611V9.167l0.199,0.1   c1.111,0.556,2.336,0.845,3.578,0.845h0V6.333l-0.113-0.028c-2.154-0.538-3.665-2.474-3.665-4.694v0H12.944z"
        />
      </g>
    </SvgIcon>
  );
}
